// Textes de la page des capteurs
export const SENSORS_TEXTS = {
  title: 'Capteurs',
  addSensor: 'Ajouter un capteur',
  moveSensor: 'Déplacer le capteur',
  deleteSensor: 'Supprimer le capteur',
  name: 'Nom',
  serialNumber: 'Numéro de série',
  brand: 'Marque',
  model: 'Modèle',
  alertCount: 'Alertes',
  lastDataDate: 'Dernières données',
  locationName: 'Emplacement',
  newLocation: 'Nouvel emplacement',
  newOrganization: 'Nouvelle organisation',
  loading: 'Chargement des capteurs...',
  errorLoading: 'Erreur lors du chargement des capteurs',
  noSensors: 'Aucun capteur trouvé',
  noData: 'Aucune donnée',
  searchPlaceholder: 'Rechercher des capteurs...',
  selectLocation: 'Sélectionner un emplacement',
  noLocationsFound: 'Aucun emplacement trouvé',
  allLocations: 'Tous les emplacements',
  selectFilters: 'Sélectionner des filtres',
  selectOrgAndLocationMessage: 'Veuillez sélectionner des filtres pour voir les capteurs',
  selectLocationMessage: 'Veuillez sélectionner un emplacement pour voir les capteurs',
  selectOrgAndLocationDescription: 'Utilisez le panneau de filtres ci-dessus pour sélectionner une organisation et un emplacement.',
  selectLocationDescription: 'Utilisez le panneau de filtres ci-dessus pour sélectionner un emplacement pour voir ses capteurs.',
  errors: {
    SENSOR_NAME_REQUIRED: 'Le nom du capteur est requis',
    SENSOR_SERIAL_NUMBER_REQUIRED: 'Le numéro de série est requis',
    SENSOR_LOCATION_REQUIRED: 'L\'emplacement est requis',
    SENSOR_BRAND_REQUIRED: 'La marque est requise',
    SENSOR_MODEL_REQUIRED: 'Le modèle est requis',
    SENSOR_ID_REQUIRED: 'L\'ID du capteur est requis',
    SENSOR_NAME_EMPTY: 'Le nom du capteur ne peut pas être vide',
    SENSOR_SERIAL_NUMBER_EMPTY: 'Le numéro de série ne peut pas être vide',
    SENSOR_LOCATION_EMPTY: 'L\'emplacement ne peut pas être vide',
    SENSOR_BRAND_EMPTY: 'La marque ne peut pas être vide',
    SENSOR_MODEL_EMPTY: 'Le modèle ne peut pas être vide',
    NEW_LOCATION_REQUIRED: 'Le nouvel emplacement est requis',
    NEW_ORGANIZATION_REQUIRED: 'La nouvelle organisation est requise',
    CREATE_SENSOR_FAILED: 'Échec de la création du capteur',
    UPDATE_SENSOR_FAILED: 'Échec de la modification du capteur',
    DELETE_SENSOR_FAILED: 'Échec de la suppression du capteur',
    MOVE_SENSOR_FAILED: 'Échec du déplacement du capteur'
  },
  // Textes de la carte capteur
  sensorCard: {
    status: {
      online: 'En ligne',
      offline: 'Hors ligne'
    },
    lastData: 'Dernières données',
    noData: 'Aucune donnée disponible',
    actions: {
      exportCSV: 'Exporter CSV',
      showData: 'Afficher les données',
      viewAlerts: 'Voir les alertes',
      edit: 'Modifier',
      move: 'Déplacer',
      remove: 'Supprimer'
    },
    tooltips: {
      exportCSV: 'Exporter les données du capteur en CSV',
      showData: 'Voir le graphique des données du capteur',
      viewAlerts: 'Voir les alertes attachées',
      edit: 'Modifier les détails du capteur',
      move: 'Déplacer le capteur vers un autre emplacement',
      remove: 'Supprimer ce capteur'
    },
    units: {
      temperature: '°C',
      humidity: '%',
      pressure: 'hPa',
      voltage: 'V',
      current: 'A',
      power: 'W',
      percentage: '%'
    },
    labels: {
      temperature: 'Température',
      humidity: 'Humidité',
      status: 'Statut',
      current: 'Courant',
      total_current: 'Courant total'
    },
    alerts: {
      triggered: 'Alertes déclenchées',
      pending: 'Alertes en attente',
      active: 'Alertes actives',
      count: 'alertes'
    }
  },
  // Textes du dialogue de confirmation de suppression
  deleteConfirmation: {
    title: 'Supprimer le capteur',
    message: 'Êtes-vous sûr de vouloir supprimer ce capteur ?',
    messageWithName: (name: string) => `Êtes-vous sûr de vouloir supprimer "${name}" ? Cette action ne peut pas être annulée.`,
    confirmButton: 'Supprimer',
    cancelButton: 'Annuler'
  },
  // Textes du dialogue de déplacement de capteur
  moveDialog: {
    title: 'Déplacer le capteur',
    currentLocation: 'Emplacement actuel',
    newLocation: 'Déplacer vers un nouvel emplacement',
    selectOrganization: 'Sélectionner une organisation',
    selectLocation: 'Sélectionner un emplacement',
    moveButton: 'Déplacer',
    moving: 'Déplacement...',
    errorSelectLocation: 'Veuillez sélectionner un emplacement',
    errorSameLocation: 'Veuillez sélectionner un emplacement différent',
    labels: {
      organization: 'Organisation :',
      location: 'Emplacement :',
      sensor: 'Capteur :'
    },
    defaultError: 'Échec du déplacement du capteur'
  },

  // Textes du dialogue de données de capteur
  dataDialog: {
    title: 'Données du capteur',
    modes: {
      viewOnly: 'Voir les données',
      exportOnly: 'Exporter CSV',
      viewAndExport: 'Voir et exporter'
    },
    sensorInfo: 'Informations du capteur',
    dateRange: 'Plage de dates',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    selectFields: 'Sélectionner les champs à exporter',
    viewButton: 'Charger les données',
    exportButton: 'Exporter CSV',
    exportVisibleButton: 'Exporter les données visibles',
    exportAllButton: 'Exporter toutes les données',
    closeButton: 'Fermer',
    loading: 'Chargement des données...',
    viewing: 'Chargement...',
    exporting: 'Exportation...',
    exportCsvButton: 'Exporter CSV',
    exportExcelButton: 'Exporter Excel',
    exportCsvVisibleButton: 'CSV Visible',
    exportExcelVisibleButton: 'Excel Visible',
    tableTitle: 'Mesures du capteur',
    noDataFound: 'Aucune donnée trouvée pour la plage de dates sélectionnée',
    dataLoadedSuccess: (count: number) => `${count} mesures chargées`,
    labels: {
      sensor: 'Capteur :'
    },
    fields: {
      timestamp: 'Horodatage',
      temperature: 'Température (°C)',
      humidity: 'Humidité (%)',
      status: 'Statut',
      current: 'Courant (A)',
      total_current: 'Courant total (A)'
    },
    table: {
      timestamp: 'Date et heure',
      temperature: 'Température',
      humidity: 'Humidité',
      status: 'Statut',
      current: 'Courant',
      total_current: 'Courant total',
      rowsPerPage: 'Lignes par page :',
      noData: 'Aucune mesure à afficher'
    },
    errors: {
      noFieldsSelected: 'Veuillez sélectionner au moins un champ à exporter',
      missingDates: 'Veuillez sélectionner les dates de début et de fin',
      invalidDateRange: 'La date de début doit être antérieure à la date de fin',
      loadDataFailed: 'Échec du chargement des données du capteur',
      exportFailed: 'Échec de l\'exportation des données'
    }
  },

  // Textes du dialogue d'exportation CSV (conservés pour compatibilité)
  exportDialog: {
    title: 'Exporter les données du capteur',
    sensorInfo: 'Informations du capteur',
    dateRange: 'Plage de dates',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    selectFields: 'Sélectionner les champs à exporter',
    exportButton: 'Exporter CSV',
    exporting: 'Exportation...',
    labels: {
      sensor: 'Capteur :'
    },
    fields: {
      timestamp: 'Horodatage',
      temperature: 'Température',
      humidity: 'Humidité'
    },
    errors: {
      noFieldsSelected: 'Veuillez sélectionner au moins un champ à exporter',
      missingDates: 'Veuillez sélectionner les dates de début et de fin',
      invalidDateRange: 'La date de début doit être antérieure à la date de fin',
      exportFailed: 'Échec de l\'exportation des données'
    }
  },
  moving: 'Déplacement...',

  // Textes du dialogue d'historique des données
  dataHistoryDialog: {
    title: 'Historique des données',
    sensorLabel: 'Capteur :',
    noData: 'Aucune donnée disponible'
  },

  // Textes du dialogue de document JSON du capteur
  documentDialog: {
    title: 'Document JSON du capteur',
    sensorLabel: 'Capteur :',
    description: 'Visualisation du document complet du capteur en format JSON'
  },

  // Textes du dialogue des alertes attachées
  alertsDialog: {
    title: 'Alertes du capteur',
    closeButton: 'Fermer',
    noAlerts: 'Aucune alerte attachée à ce capteur'
  }
} as const;